import addEventListener from 'dom-helpers/events/on';
import removeEventListener from 'dom-helpers/events/off';
export default function (node, event, handler, capture) {
  addEventListener(node, event, handler, capture);
  return {
    remove: function remove() {
      removeEventListener(node, event, handler, capture);
    }
  };
}


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-overlay/src/utils/addEventListener.js